const config = {
  routes: {
    label: 'Promotions',
    prefix: '/promotions',
  },
}

export default config
